import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "person-container"
}
const _hoisted_2 = { class: "text-bold" }
const _hoisted_3 = { class: "row no-wrap justify-between" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.person.Id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.person.Name), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.person.Post), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.getAddress), 1)
        ]),
        _createElementVNode("span", {
          style: {"white-space":"break-spaces"},
          innerHTML: _ctx.person.Contacts
        }, null, 8, _hoisted_4)
      ]))
    : _createCommentVNode("", true)
}